export const numberToString = (number: number): string => {
  if (number === undefined || number === null) {
    return '0'
  }
  return Number(number).toLocaleString('ru')
}
